import React from 'react';

import TextBase from './TextBase';
import { TText } from './types';

const Large = ({ as = 'span', color = '', strong = false, ...rest }: TText) => (
  <TextBase as={as} kind={`body-large${strong ? '-strong' : ''}`} color={color} {...rest} />
);

export default Large;
